// This is a simple blue line divider component.
// The width, top/bottom margins, and color can be
// controlled via props.

import * as React from "react";

interface DividerProps {
    width?: string;
    gap?: string;
    color?: string;
}

class Divider extends React.Component<DividerProps> {
    public render() {
        const { color, gap, width } = this.props;
        const styles = {
            background: color || "#68ccdd",
            height: "2px",
            margin: "auto",
            marginBottom: gap || "10px",
            marginTop: gap || "10px",
            width: width || "80px",
        };
        return <div className="Divider" style={styles} />;
    }
}

export default Divider;
